function getStyleWithVertices(style, verticesStyle, showVertices) {
  if (style && verticesStyle && showVertices) {
    return [style, verticesStyle];
  }

  if (style) {
    return [style];
  }

  return undefined;
}

export default getStyleWithVertices;